import { gql } from "@apollo/client";

export const GET_COURSE_MOMENT = gql`
  query CourseMoment($id: ID!, $categories: [String]) {
    certCourseMoment(id: $id) {
      id
      title
      college
      orderer
      start_date
      end_date
      notes
      billing_address
      author {
        id
        name
        type
      }
      done
      created_at
      updated_at
      stakeholders {
        id
        name
        email
        firstname
        lastname
      }
    }
    allGroups(categories: $categories, byPassMembership: true) {
      id
      title
    }
  }
`;

export const GET_COURSE_MOMENTS = gql`
  query CourseMoments(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetCourseMomentsOrderByClause]
  ) {
    certCourseMoments(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        id
        title
        start_date
        end_date
        college
        orderer
        author {
          id
          name
          email
          type
        }
        notes
        done
        created_at
        updated_at
        items
        participantsCount
        type
        collegeObject {
          id
          title
        }
        ordererObject {
          id
          title
        }
        participants {
          id
          firstname
          lastname
          personal_number
        }
      }
    }
  }
`;
